import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
} from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';
import { useDeleteWebhook } from '../../../hooks/useWebhooks';
import { Webhook } from '../../../types/webhook';
import { styled } from '@mui/material/styles';
import { COLOR } from '../../../theme';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: COLOR.whiteSmoke,
    color: COLOR.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

interface Props {
  webhooks: Webhook[];
}

const WebhookList: React.FC<Props> = ({ webhooks }) => {
  const { mutate: deleteWebhook } = useDeleteWebhook();

  const handleDelete = (id: string) => {
    deleteWebhook(id);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">Name</StyledTableCell>
            {/* <TableCell>Signing Secret</TableCell> */}
            <StyledTableCell align="center">Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {webhooks.map((webhook) => (
            <TableRow key={webhook.id}>
              <TableCell align="center">{webhook.name}</TableCell>
              {/* <TableCell>{webhook.clockify_signing_secret}</TableCell> */}
              <TableCell align="center">
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDelete(webhook.id)}
                  >
                    Delete
                  </Button>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WebhookList;
